import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import ArtworkList from './components/ArtworkList';
import SingleImagePage from './components/SingleImagePage';
import MasonryImagesPage from './components/MasonryImagesPage';
import ImageCollagePage from './components/ImageCollagePage';
import './App.css';

function App() {
  useEffect(() => {
    document.title = "Museo AI";
  }, []);

  return (
    <Router>
      <div className="App">
        <div className="p-4">
          <Routes>
            <Route path="/" element={<ArtworkList />} />
            <Route path="/single-image" element={<SingleImagePage />} />
            <Route path="/masonry-images" element={<MasonryImagesPage />} />
            <Route
              path="/collage"
              element={<ImageCollagePage />}
            />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
